import { useContext } from "react";
import { Navigate } from "react-router";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingContent } from "./LoadingContent";
import { UserType } from "../../Variables";

export const AdminAndAgencyOnlyRoute = (props: React.PropsWithChildren<any>) => {
    const app = useContext(AppContext);

    if (!app.loading && (app.loggedInUser.UserType == UserType.Candidate || app.loggedInUser.UserType == UserType.Anonymous)) {
        // user is not allowed
        return <Navigate to="/" />;
    }

    return (<>
        <LoadingContent loading={app.loading} classes="w-100 text-center">
            {props.children}
        </LoadingContent>
    </>);
}